import React from "react";
import { localize } from "redux-i18n";
import { ChartJS } from "@components";
import type { AbsenceStatistics } from "@modules/shared/reducer/employee-absences/types";

type Props = $Exact<{
  ...PropsFromLocalize,
  data: AbsenceStatistics,
}>;

export class AbsenceStatisticPerEmployee extends React.Component<Props> {
  get chartData() {
    return [
      [this.props.t("NUMBER_OF_DAYS"), this.props.t("SHORT_TERM"), this.props.t("LONG_TERM")],
      ...this.props.data.dlpeBenchmarking.map(item => [
        item.description,
        item.value[0].value,
        item.value[1].value,
      ]),
    ];
  }

  render() {
    return (
      <ChartJS
        type="bar"
        title={this.props.t("REPORT_COLUMN_TIME_LOST_PER_EMPLOYEE")}
        data={{
          labels: this.chartData.slice(1).map(([label]) => label),
          datasets: [
            { label: this.props.t("SHORT_TERM"), data: this.chartData.slice(1).map(([, s]) => s) },
            { label: this.props.t("LONG_TERM"), data: this.chartData.slice(1).map(([, , l]) => l) },
          ],
        }}
        options={{ animation: false, wrapXAxisLabels: true }}
      />
    );
  }
}

export default localize()(AbsenceStatisticPerEmployee);
